/**
 * EnviroTech Australia — Contact Page Tab Controller
 *
 * Handles:
 *  • Tab switching via CSS class (NOT the hidden attribute, so POWR
 *    can initialise all forms regardless of which tab is visible)
 *  • URL hash deep-linking  (/pages/contact#sds)
 *  • Sidebar quick-link buttons that switch tab + smooth-scroll
 *  • Keyboard navigation (arrow keys between tabs)
 *  • Re-triggering POWR render when switching to a new tab
 */
(function () {
  'use strict';

  var SELECTORS = {
    tab: '.eta-tabs__btn',
    panel: '.eta-tab-panel',
    switchBtn: '[data-switch-tab]',
  };

  var CLASSES = {
    tabActive: 'eta-tabs__btn--active',
    panelActive: 'eta-tab-panel--active',
  };

  /* ── Activate a tab by its data-tab key ───────────────────────── */
  function activateTab(tabKey) {
    /* Update tab buttons */
    document.querySelectorAll(SELECTORS.tab).forEach(function (btn) {
      var isTarget = btn.getAttribute('data-tab') === tabKey;
      btn.classList.toggle(CLASSES.tabActive, isTarget);
      btn.setAttribute('aria-selected', isTarget ? 'true' : 'false');
    });

    /* Update panels — CSS only, no hidden attribute */
    document.querySelectorAll(SELECTORS.panel).forEach(function (panel) {
      var isTarget = panel.getAttribute('data-panel') === tabKey;
      panel.classList.toggle(CLASSES.panelActive, isTarget);
    });

    /* Tell POWR to re-check the now-visible panel.
       POWR exposes a global reinit method on some versions.
       We also dispatch a resize event as a fallback — many
       third-party widgets listen for resize to re-layout. */
    try {
      if (window.POWR && typeof window.POWR.reinit === 'function') {
        window.POWR.reinit();
      }
      window.dispatchEvent(new Event('resize'));
    } catch (e) {
      /* silent — not critical */
    }

    /* Update URL hash without scrolling */
    if (history.replaceState) {
      history.replaceState(null, '', '#' + tabKey);
    }
  }

  /* ── Bind click handlers ──────────────────────────────────────── */
  function bindTabs() {
    /* Main tab buttons */
    document.querySelectorAll(SELECTORS.tab).forEach(function (btn) {
      btn.addEventListener('click', function () {
        activateTab(this.getAttribute('data-tab'));
      });
    });

    /* Sidebar quick-link / CTA buttons */
    document.querySelectorAll(SELECTORS.switchBtn).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var targetTab = this.getAttribute('data-switch-tab');
        activateTab(targetTab);

        /* Smooth scroll to the form area */
        var formsSection = document.getElementById('contact-forms');
        if (formsSection) {
          formsSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }

  /* ── Handle deep-link via URL hash on load ────────────────────── */
  function handleHash() {
    var hash = window.location.hash.replace('#', '');
    if (hash) {
      var matchingTab = document.querySelector(
        SELECTORS.tab + '[data-tab="' + hash + '"]'
      );
      if (matchingTab) {
        activateTab(hash);
      }
    }
  }

  /* ── Keyboard: arrow-key navigation between tabs ──────────────── */
  function bindKeyboard() {
    var tabList = document.querySelector('[role="tablist"]');
    if (!tabList) return;

    tabList.addEventListener('keydown', function (e) {
      var tabs = Array.from(tabList.querySelectorAll(SELECTORS.tab));
      var currentIndex = tabs.indexOf(document.activeElement);
      if (currentIndex === -1) return;

      var newIndex;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
        newIndex = (currentIndex + 1) % tabs.length;
      } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
        newIndex = (currentIndex - 1 + tabs.length) % tabs.length;
      } else if (e.key === 'Home') {
        newIndex = 0;
      } else if (e.key === 'End') {
        newIndex = tabs.length - 1;
      } else {
        return;
      }

      e.preventDefault();
      tabs[newIndex].focus();
      activateTab(tabs[newIndex].getAttribute('data-tab'));
    });
  }

  /* ── Init ──────────────────────────────────────────────────────── */
  function init() {
    bindTabs();
    bindKeyboard();
    handleHash();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
